module.exports = __webpack_public_path__ + "static/img/in.54e807ae.png";